module.exports = __webpack_public_path__ + "img/release-video.d052800.png";